import * as Sentry from "@sentry/react";
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ModalProvider } from './contexts/ModalContext';
import HomePage from './components/HomePage';
import LoginPage from './components/LoginPage';
import SuiteDashboard from './components/SuiteDashboard';
import AssessDashboard from './components/AssessDashboard';
import PlannerDashboard from './components/PlannerDashboard';
import MarkWorkPage from './components/MarkWorkPage';
import MySoLPage from './components/MySoLPage';
import MyInfoPage from './components/MyInfoPage';
import CancelMembershipPage from './components/CancelMembershipPage';
import ToolsPage from './components/ToolsPage';
import PurchasePage from './components/PurchasePage';
import ContactPage from './components/ContactPage';
import PlannerFormPage from './components/PlannerFormPage';
import PlannerResultPage from './components/PlannerResultPage';
import PlannerLibraryPage from './components/PlannerLibraryPage';
import PDFGuidePage from './components/PDFGuidePage';
import ResourceGeneratorForm from './components/ResourceGeneratorForm';
import ResourceResultPage from './components/ResourceResultPage';
import PublicPDFGuidePage from './components/PublicPDFGuidePage';
import UpgradePage from './components/UpgradePage';
import LegalPage from './components/LegalPage';
import CookieConsent from "react-cookie-consent";
import FeedbackPage from './components/Feedback';
import InsightsDashboard from './components/InsightsDashboard';
import NotFoundPage from './components/NotFoundPage';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.NODE_ENV,
});

window.gtag = window.gtag || function() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
};

const script = document.createElement('script');
script.async = true;
script.src = 'https://www.googletagmanager.com/gtag/js?id=G-6DC5CDJ829';
document.head.appendChild(script);

window.gtag('js', new Date());
window.gtag('config', 'G-6DC5CDJ829', {
  analytics_storage: 'denied',
  ad_storage: 'denied'
});

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <ModalProvider>
          <Router>
            <div className="App">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/dashboard" element={<SuiteDashboard />} />
                <Route path="/assess" element={<AssessDashboard />} />
                <Route path="/planner" element={<PlannerDashboard />} />
                <Route path="/planner/form" element={<PlannerFormPage />} />
                <Route path="/planner/result" element={<PlannerResultPage />} />
                <Route path="/mark-work" element={<MarkWorkPage />} />
                <Route path="/my-sol" element={<MySoLPage />} />
                <Route path="/my-info" element={<MyInfoPage />} />
                <Route path="/cancel-membership" element={<CancelMembershipPage />} />
                <Route path="/tools" element={<ToolsPage />} />
                <Route path="/pricing" element={<PurchasePage />} />
                <Route path="/contact" element={<ContactPage/>}/>
                <Route path="/planner/library" element={<PlannerLibraryPage />} />
                <Route path="/pdf-guide" element={<PDFGuidePage />} />
                <Route path="/planner/resources" element={<ResourceGeneratorForm />} />
                <Route path="/planner/resources/result" element={<ResourceResultPage />} />
                <Route path="/help/pdf-guide" element={<PublicPDFGuidePage />} />
                <Route path="/upgrade" element={<UpgradePage />} />
                <Route path="/legal/:type" element={<LegalPage />} />
                <Route path="/feedback" element={<FeedbackPage />} />
                <Route path="/insights" element={<InsightsDashboard />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
              <CookieConsent
                location="bottom"
                buttonText="Accept All"
                enableDeclineButton
                declineButtonText="Decline"
                cookieName="gdpr-consent"
                style={{ background: "#2B373B" }}
                buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
                expires={150}
                onAccept={() => {
                  window.gtag('consent', 'update', {
                    analytics_storage: 'granted',
                    ad_storage: 'granted'
                  });
                }}
                onDecline={() => {
                  window.gtag('consent', 'update', {
                    analytics_storage: 'denied',
                    ad_storage: 'denied'
                  });
                }}
              >
                We use cookies to improve your experience and analyze site usage.
                By clicking "Accept All", you consent to our use of cookies.
              </CookieConsent>
            </div>
          </Router>
        </ModalProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;